import { BuildingSource } from '@visualizer/types';

export default class Triangle {
    A: number;
    B: number;
    C: number;
    ID: number;
    buildingSource?: BuildingSource;

    constructor() {
        this.A = 0;
        this.B = 0;
        this.C = 0;
        this.ID = 0;
    }
}
